import questionService from '../services/QuestionService';
import promptService from '../services/PromptService';
import lessonManager from '../managers/LessonManager';

import { ImageLabelBehavior } from './ImageLabelBehavior';

export class ImageLabelDragDropBehavior extends ImageLabelBehavior {

  isAnswerCorrect = (answerId, lessonElementState, model) => {
    const answerResults = lessonElementState?.currentResponseAnswer?.answerResults;
    if (answerResults && answerResults.length > 0) {
      const result = answerResults.find((r) => r.answerId === answerId);
      if (result !== undefined) {
        return Boolean(result.match);
      }
    }

    const userInputMap = lessonElementState?.currentResponseAnswer.userInputMap || questionService.updateUserInputMap({
      model,
      responseAnswer: lessonElementState.currentResponseAnswer,
      lessonElementState
    });
    const currentUserInput = userInputMap?.get(answerId);
    const currentUserInputValue = currentUserInput?.text;
    return promptService.isCorrectPromptAnswerStatus({
      dataId: answerId, currentUserInput, currentUserInputValue, model
    });
  }

  setResponseData = (data, _responseAnswer, model, { dataId, lessonElementState, oldDataId } = {}) => {
    const payload = data ? { ...data, dataId, answerId: data.id } : data;
    if (!lessonElementState.currentResponseAnswer.userInputMap) {
      const userInputMap = questionService.updateUserInputMap({ model, lessonElementState });
      if (dataId) {
        userInputMap.set(dataId, payload);
      }
      if (oldDataId) {
        userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
      lessonManager.stampResponsePublisherTranslationId(lessonElementState?.currentResponseAnswer);
      return userInputMap;
    } else {
      if (dataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(dataId, payload);
      }
      if (oldDataId) {
        lessonElementState.currentResponseAnswer.userInputMap.set(oldDataId, {
          dataId: oldDataId,
          text: ''
        });
      }
      lessonManager.stampResponsePublisherTranslationId(lessonElementState?.currentResponseAnswer);
      return lessonElementState.currentResponseAnswer.userInputMap;
    }
  }
}

export default new ImageLabelDragDropBehavior();
